export default __webpack_public_path__ + "static/media/Arm-straps of Deadly Guile.f39d19d2.jpg";